import { render, staticRenderFns } from "./IncomeSpaceSettings.vue?vue&type=template&id=5c4ffa4e&scoped=true&"
import script from "./IncomeSpaceSettings.vue?vue&type=script&lang=js&"
export * from "./IncomeSpaceSettings.vue?vue&type=script&lang=js&"
import style0 from "./IncomeSpaceSettings.vue?vue&type=style&index=0&id=5c4ffa4e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c4ffa4e",
  null
  
)

export default component.exports